import { CommonUtilities } from "../../commonUtils";


export default class gridTemplateService {


    /* Contact Grid */
    static ContactListing(data: {}) {
        var url = 'royalty/contactList';
        return CommonUtilities.postData(url, data);
    }

    static exportContact(data: any) {
        const url = 'royalty/contactList?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, data.exportType, data.type);
    };

    static savecontactsGridResult(data: any) {
        var url = 'metadata/globalUserSearch?type=contactsGridResult';
        return CommonUtilities.postData(url, data);
    }

    static ContractListing(data: any) {
        var url = 'royalty/contractList' ///+ CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.postData(url, data);
    }

    static ExportContractDetails(data: {}) {
        var url = 'royalty/contractList';
        return CommonUtilities.postData(url, data);
    }

    static projectListing(data: {}) {
        var url = 'licensing/projectList';
        return CommonUtilities.postData(url, data);
    }

    static SplitsListing(param: any) {
        var url = 'contracts/financialPerformance?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getAllClientZones(param: any) {
        var url = 'contracts/zones/getAllClientZones?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static AllSplit(data: {}) {
        var url = 'metadata/publishingSplitsTrack/allsplit?';
        return CommonUtilities.postData(url, data);
    }

    static updateTrackSplitRole(data: any) {
        var url = 'metadata/publishingSplitsTrack/updateTrackSplitRole';
        return CommonUtilities.postData(url, data);
    }

}